import { Button, Modal, Text } from '@driftt/dds'
import React from 'react'

import { capitalizeFirstLetter } from 'utils/index'

const ConfirmationModal = ({
  isOpen,
  onClose,
  onAction,
  action = '',
}: {
  isOpen: boolean
  onClose: () => void
  onAction: () => void
  action?: string
}) => (
  <Modal.Root open={isOpen} onClose={onClose}>
    <Modal.Dialog
      fullWidth
      size="small"
      variant={action === 'delete' ? 'error' : 'warning'}
    >
      <Modal.Title title={`${capitalizeFirstLetter(action)} scenario?`} />
      {action === 'delete' && (
        <Modal.Content>
          <Text>This action cannot be undone.</Text>
        </Modal.Content>
      )}
      <Modal.Actions>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant={action === 'delete' ? 'error' : 'primary'}
          onClick={onAction}
        >
          Yes, {action}
          {action === 'delete' && ' permanently'}
        </Button>
      </Modal.Actions>
    </Modal.Dialog>
  </Modal.Root>
)

export default ConfirmationModal
